import React from 'react';
import I18N from './Strings'

export const I18NContext = React.createContext(new I18N());